import feuArtifice from '../../assets/feu_artifice.jpeg';
import osteo from '../../assets/osteo.jpeg';
import standTir from '../../assets/paintball.jpeg';
import murChampion from '../../assets/mur_champion.jpeg';
import sautElastique from '../../assets/saut_elastique.jpeg';
import bubbleSoccer from '../../assets/bubble_soccer.jpeg';
import soiree from '../../assets/toss_soiree4.jpeg'

const images = [
    {
        src: feuArtifice,
        title : "feu"
    },
    {
        src: osteo,
        title:'Osteo'
    },
    {
        src: standTir,
        title:'stand'
    },
    {
        src:murChampion,
        title:"actis"
    },
    {
        src:sautElastique,
        title:"saut",
    },
    {
        src:bubbleSoccer,
        title:"bubble"
    },
    {
        src: soiree,
        title:"soiree"
    }
]

export default images